<template>
	<div style="margin: 10px;">
		<el-card class="box-card">
			<el-row>
				<el-col :span="12">
					<h4 class="title">参数信息</h4>
					<el-form ref="form" :model="form" label-width="120px" :rules="rules">
						<el-form-item label="素材标题" prop="title">
							<el-input v-model="form.title" placeholder="添加栏目名称"></el-input>
						</el-form-item>
						<el-form-item label="素材描述" prop="desc">
							<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 4}" placeholder="请输入内容" v-model="form.desc">
							</el-input>
						</el-form-item>
						<el-form-item label="选择图片素材" prop="pic">
							<!-- <el-input v-model="form.pic" style="width: 70%;float: left;" placeholder="请选择图片" readonly></el-input> -->
							<el-upload drag  list-type="picture-card" action="" :before-upload="beforePic" multiple :limit="1" :on-success="getPic"
							 :file-list="picList" :on-remove="RemovePic" :on-exceed="handleLogo">
							<img v-if="form.pic" :src="settings.apiBaseImg+form.pic" class="avatar">
							<i v-else class="el-icon-picture-outline avatar-uploader-icon"></i>
							<br />
							<span class="uploadTip">将图片拖到此处，或点击上传</span>
							</el-upload>
							
						</el-form-item>
						<el-form-item>
							<input type="button" class="submit" @click="onSubmit('form')" value="提交">
						</el-form-item>
					</el-form>
				</el-col>
				<!-- <el-col :span="12">
					<div class="advanPic">
						<i class="el-icon-picture-outline" v-if="showPic == ''" style="font-size: 36px;text-align: center;color: #666;"></i>
						<img :src="showPic" alt="" v-if="showPic != ''">
					</div>
				</el-col> -->

			</el-row>
		</el-card>
	</div>
</template>

<script>
	import qs from 'qs'
	export default {
		data() {
			return {
				form: {
					desc: '',
					title: '',
					pic: '',
					logo: '',
					id: '',
					width: '',
					height: '',
					size: '',
					oldName: '',
					newName: ''
				},
				rules: {
					pic: [{
						required: true,
						message: '请输入图片',
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: '请输入素材标题',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请输入素材描述',
						trigger: 'blur'
					}],
				},
				picList: [],
				showPic: ''
			}
		},
		created() {
			if (this.$route.query.iden == 'update') {
				this.form.title = this.$route.query.rows.title
				this.form.desc = this.$route.query.rows.contents
				this.form.pic = this.$route.query.rows.path
				this.form.id = this.$route.query.rows.id
				this.form.width = this.$route.query.rows.width
				this.form.height = this.$route.query.rows.height
				this.form.oldName = this.$route.query.rows.oldName
				this.form.newName = this.$route.query.rows.newName
				this.form.size = this.$route.query.rows.size
			}
		},
		methods: {
			//添加
			onSubmit(formName) {
				if (this.$route.query.iden == 'add') {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							var obj = this;
							obj.$http({
								method: 'post',
								url: 'api/v1/picmate/add',
								data: {
									title: this.form.title,
									oldName: this.form.oldName,
									newName: this.form.newName,
									path: this.form.pic,
									size: this.form.size,
									width: this.form.width,
									height: this.form.height,
									contents: this.form.desc,
								},
							}).then((res) => {
								if (res.data.status == 200) {
									obj.$message.success(res.data.message)
									this.$router.push({
										path: '/home/library'
									})
									this.form.title = '',
										this.form.oldName = '',
										this.form.newName = '',
										this.form.pic = '',
										this.form.size = '',
										this.form.width = '',
										this.form.height = '',
										this.form.desc = ''
								} else {
									obj.$message.error(res.data.message)
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.onUpdate()
				}

			},
			//修改
			onUpdate() {
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/picmate/update',
					data: {
						id: this.form.id,
						title: this.form.title,
						oldName: this.form.oldName,
						newName: this.form.newName,
						path: this.form.pic,
						size: this.form.size,
						width: this.form.width,
						height: this.form.height,
						contents: this.form.desc,
					},
				}).then((res) => {
					if (res.data.status == 200) {
						obj.$message.success(res.data.message)
						this.$router.push({
							path: '/home/library'
						})
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},

			//上传图片
			getPic(file, fileList) {
				this.form.pic = file.data.path
				this.form.width = file.data.width
				this.form.height = file.data.height
				this.form.oldName = file.data.oldName
				this.form.newName = file.data.newName
				this.form.size = file.data.size
				this. this.form.pic =this.form.pic
			},
			//上传图片之前调取接口
			beforePic(file, fileList) {
				let objUrl = file;
				let formData = new FormData();
				formData.append('file', objUrl);
				formData.append('uid', localStorage.getItem('uid'));
				var obj = this;
				obj.$http({
					method: 'post',
					url: 'api/v1/picmate/upload',
					data: formData,
				}).then((res) => {
					if (res.status == 200) {
						this.form.pic = res.data.data.path
						this.form.width = res.data.data.width
						this.form.height = res.data.data.height
						this.form.oldName = res.data.data.oldName
						this.form.newName = res.data.data.newName
						this.form.size = res.data.data.size
						this.form.pic = this.form.pic
						obj.$message.success(res.data.message)
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			RemovePic() {
				this.form.pic = ''
			},
			handleLogo(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
		}
	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 40px;
	}

	/deep/ .el-input__inner {
		height: 30px;
	}

	.picTip {

		height: 16px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.5;
		margin-left: 10px;
	}

	.advanPic {
		width: 380px;
		/* height: 205px; */
		vertical-align: middle;
		margin-left: 50px;
		margin-top: 50px;
		border: 1px solid #ccc;
		text-align: center;
		line-height: 205px;
	}

	.advanPic img {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/library/addLibray.vue